(() => {
  'use strict';
  function update(container, variantId) {
    if (!container) return;
    const select = container.querySelector('.product-form__variants');
    const button = container.querySelector('[name="add"]');
    if (!select || !button) return;
    const option = Array.from(select.options).find(item => item.value === String(variantId));
    const state = option?.dataset.purchaseState?.trim() || 'unavailable';
    const labels = window.Sunrise.strings.tcs_purchase;
    const preorder = state === 'preorder';
    const purchasable = ['preorder', 'in_stock', 'available'].includes(state);
    button.disabled = !purchasable;
    button.classList.toggle('tcs-preorder-button', preorder);
    button.querySelector('span').textContent = preorder ? labels.preorder_button : purchasable ? window.Sunrise.strings.add_to_cart : state === 'sold_out' ? window.Sunrise.strings.sold_out : window.Sunrise.strings.unavailable;
    const property = container.querySelector('[data-preorder-property]');
    if (property) property.disabled = !preorder;
    const payment = container.querySelector('.extra-button-wrap');
    if (payment) {
      payment.hidden = !purchasable;
      payment.classList.toggle('hide', !purchasable);
    }
    const restock = container.querySelector('[data-restock-form]');
    if (restock) restock.hidden = state !== 'sold_out';
    const message = container.querySelector('[id^="stockMsg-"]');
    if (message) {
      message.classList.remove('hide');
      const box = document.createElement('div');
      box.className = 'tcs-availability tcs-availability--' + state;
      const title = document.createElement('strong');
      title.textContent = labels[state];
      const note = document.createElement('p');
      note.textContent = labels[state + '_note'];
      box.append(title, note);
      if (preorder) {
        const link = document.createElement('a');
        link.href = window.Sunrise.strings.tcs_faq_url;
        link.textContent = labels.preorder_details;
        box.append(link);
      }
      message.replaceChildren(box);
    }
    container.querySelectorAll('[itemprop="availability"]').forEach(item => {
      item.href = 'https://schema.org/' + (preorder ? 'PreOrder' : purchasable ? 'InStock' : 'OutOfStock');
    });
    container.dispatchEvent(new CustomEvent('tcs:purchase-state', {detail: {variantId, state}}));
  }
  function initialize(root) {
    root.querySelectorAll('[data-section-type="product"]').forEach(container => {
      const select = container.querySelector('.product-form__variants');
      if (select) update(container, select.value);
    });
  }
  document.addEventListener('variantChange', event => {
    update(event.target.closest('[data-section-type="product"]'), event.detail?.variant?.id);
  });
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(document));
  else initialize(document);
})();
